import { motion } from "framer-motion";
import "./Home.css";

const foodItems = [
  {
    image: "/images/pizza.jpg",
    title: "Pizza",
    description:
      "Experience our artisanal pizzas, crafted with hand-stretched dough that’s slow-fermented for 48 hours. Our signature Margherita is built on a rich San Marzano tomato sauce layered with fresh buffalo mozzarella, fragrant basil leaves, and a drizzle of extra virgin olive oil. For those who crave variety, choose toppings like sweet corn, caramelized onions, colorful bell peppers, or even marinated paneer, ensuring every bite is an explosion of flavor.",
  },
  {
    image: "/images/sandwich.jpg",
    title: "Sandwich",
    description:
      "Our sandwiches begin with freshly baked artisanal bread, then loaded with premium ingredients. The Veg Sandwich boasts crisp lettuce, vine-ripe tomatoes, cucumbers, and a delectable tangy spread. Alternatively, our Paneer Sandwich features tender, grilled paneer marinated in traditional spices, layered with fresh greens and zesty chutneys. Every sandwich is assembled with care to deliver a harmonious blend of textures and flavors.",
  },
  {
    image: "/images/wraps.jpg",
    title: "Wraps",
    description:
      "Perfect for those on the go, our gourmet wraps are a delightful mix of convenience and flavor. The Veg Wrap features a medley of roasted bell peppers, zucchini, and mushrooms combined with fresh greens and a cooling herbed yogurt sauce. Our Paneer Wrap, meanwhile, highlights succulent marinated paneer grilled to perfection, paired with crisp veggies and a light, spicy dressing that delivers a punch of flavor in every bite.",
  },
  {
    image: "/images/waffles.jpg",
    title: "Waffles",
    description:
      "Indulge in our signature waffles that strike the perfect balance between a crisp, golden exterior and a light, tender interior. Prepared from a premium batter and cooked on a stone-heated griddle, our waffles come in a variety of flavors. Enjoy them with a rich milk chocolate drizzle, velvety white chocolate topping, or dark, indulgent chocolate sauce—and don’t miss the unique twist of cookie 'n' cream, crunchy almond, or cashew nut toppings.",
  },
  {
    image: "/images/moctails.jpg",
    title: "Mocktails",
    description:
      "Refresh and rejuvenate with our artfully crafted mocktails, where every glass is a carefully balanced blend of freshly squeezed juices and ripe, vibrant fruits. Each mocktail is designed to be an inviting fusion of sweet and tangy with refreshing herbal notes—whether it’s zingy citrus, cool mint, or aromatic botanicals.",
  },
];

export default function Home() {
  return (
    <div className="home-container">
      <div className="home">
        {foodItems.map((item, index) => (
          <motion.div
            className="food-section"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            key={index}
          >
            <div className="image-container">
              <img src={item.image} alt={item.title} className="food-image" />
            </div>
            <div className="overlay">
              <h2>{item.title}</h2>
              <p>{item.description}</p>
              <button className="order-btn">Order Now</button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
